define('post-editor',['tinymce-post', 'numeric-input', 'post-editor/sidebar', 'tooltip-notifier', 'ajax-loader'],
function(tinymce, NumericInput, Sidebar, tooltipNotifier, ajaxLoader) {
	var editorSelector = "#post-text-input";

	// tinymce editor instance
	var editor = null;

	var sidebar = null;

	/**
	 * Replaces the #post-text-input textarea with the tinymce instance and populates the editor variable
	 */
	function initTinyMCE() {
		tinymce.init({
			selector: editorSelector,
			content_css : "/css/post-content.min.css?v=1",
			body_class: "post-content post-editor-content" + (isIE() ? " ie" : ""),

		    theme: "modern",
		    menubar : false,
		    statusbar : false,
		    //language : 'de', // is now the default
		   	plugins : 'table, wa5_image, wa5_image_cropping, hr, textcolor, charmap, wa5_headings, wa5_math, wa5_fixbreak, wa5_tableresize paste',
		   	toolbar1: "wa5_h1 wa5_h2 | bold italic underline superscript subscript | forecolor backcolor | alignleft aligncenter alignright | removeformat",
		   	toolbar2: "wa5_image wa5_math table hr charmap | bullist numlist outdent indent blockquote | undo redo ",
		   	relative_urls: false, // WissenA5 has an absolute url concept

		   	// disallows e.g. <table width>
		   	schema: "html5-strict",

		    font_formats: "Courier='courier new', courier, monospace;"+
		    "Georgia=georgia, palatino, serif;"+
		    "Verdana=verdana, geneva, sans-serif", // this should literally match the css rule

		    fontsize_formats: "13=13px 14=14px 15=15px 16=16px 17=17px 18=18px 19=19px 20=20px",

		   	formats: {
				removeformat: [
					{block: 'h1', remove: 'all'},
					{block: 'h2', remove: 'all'},
					{block: 'blockquote', remove: 'all'},
					{selector: 'b,strong,em,i,font,u,strike,sub,sup', remove: 'all', split: true, expand: false, block_expand: true, deep: true},
					{selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true},
					{selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true}
				]
			},

			setup: function(ed) {
				editor = ed;
				window.editor = editor;
				sidebar = new Sidebar(editor);

				ed.on('LoadContent SaveContent', function() {
					ed.setContent(ed.getContent().replace(/&nbsp;/g, ' '));
				});

				ed.on('PastePostProcess', function(e) {
					var images = $(editor.getBody()).find('img:not([data-definition])');
					if (images.length) {
						images.remove();
						tooltipNotifier.showInfo(ed.getContainer(),
								'Bitte verwende die Bild-Funktion des Editors <span class="mce-ico mce-i-image"></span>, um Bilder einzufügen.', "Hinweis", "editor-past-image-tooltip");
					}
				});

				// Defer sidebar initialization to prevent layout issues
				setTimeout(function() {
					ed.on('NodeChange', function(e) {
						if (sidebar)
							sidebar.showForElement(ed.selection.getNode());
					});
				}, 0);

				warnOnUnsavedChanges();
			}
		});
	}

	function isIE() {
		if (navigator.appName === "Microsoft Internet Explorer") {
			// IE < 10
			return true;
		} else if (navigator.appName === "Netscape" && /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.test(navigator.userAgent)) {
			// IE >= 10
			return true;
		}
		return false;
	}

	function warnOnUnsavedChanges() {
		ajaxLoader.on("beforeunload", cancelLoadingOnUnsavedChanges);
	}

	function cancelLoadingOnUnsavedChanges(e) {
		if (editor.isDirty()) {
			e.cancelLoading = true;
			e.confirmationMessage = "Ungespeicherte Änderungen verwerfen?";
		} else {
			return true; // leave the page and remove this listener
		}
	}

	return {
		init: function() {
			sidebar = null;
			initTinyMCE();
		},

		destroy: function() {
			if (editor)
				editor.remove();
			$('#math-editor').remove();
		}
	};
});

